<script setup lang="ts">
    import type {ICpArticle} from '~/types';

    const props = defineProps<{
      product: ICpArticle
    }>();

    const {data} = await useEtaCalculator({
      baseMax: props.product.etaRange[1],
      baseMin: props.product.etaRange[0],
      productType: props.product.type,
    }, '', {server: false});
</script>

<template>
    <CpSectionPdpEta v-if="data" :eta="data" :is-esd="product.isEsd" />
    <div v-else class="cp-row-eta-skeleton">
        <CpIconStandard icon="calendar_today" class="cp-row-eta-skeleton__icon" type="primary" />
    </div>
</template>

<style scoped lang="scss">
.cp-row-eta-skeleton {
  display: flex;
  align-items: center;
  padding: $cp-gutter-small $cp-gutter;
  border-bottom: 1px solid var(--color-neutral-extra-light);

  &__icon {
    margin-right: $cp-gutter-xsmall;
  }
}

</style>
